module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/product-components/slug/slug.component.css
// module id = ./src/app/product-components/slug/slug.component.css
// module chunks = main